import { Observable } from 'rxjs';

import { SystemStatus } from '@shure/cloud/shared/models/devices';

export abstract class SystemStatusApiService {
	public abstract getSystemStatus$(): Observable<SystemStatus>;
}
